export const forms = {
    init: function () {

        jQuery(document).on(
          "gform_confirmation_loaded",
          function (event, formId) {
            $(".fancybox__backdrop").addClass('confirmation-loaded');
          }
        );

        $(".populate-clinics").find("select").find('option').each(function(index){
            if ($(this).html() == "optgroup") {
              $(`<optgroup label="${$(this).val()}">`).insertAfter($(this));
              $(this).remove();
            }
        });

        if (WPURLS.post_type == "traitement") {
            $(".populate-posts").find("select").val(WPURLS.post_title);
            if($('#clinic-title').length) {
                const clinic = $("#clinic-title").html();
                $(".populate-clinics").find("select").val(clinic);
            }
        }

        if (WPURLS.post_type == "specialiste") {
            setTimeout(function () {
              forms.populateFieldsExpert();
            }, 500);
        }


        //Auto-select clinic if in single clinic page
        if(WPURLS.post_type == 'wpsl_stores') {
            $('.populate-clinics').find(`select option[data-clinic-id=${WPURLS.post_id}]`).prop('selected', true);
            setTimeout(function(){
                forms.populateFields();
            }, 500)
        }
        //Hide treatments not assign to selected clinic
        $('.populate-clinics').find('select').on('change', forms.populateFields);
        $(".clinic-email").find("input[type=email]").val(WPURLS.info_email);

        $('select').on('change', function() {
            if ($(this).val()) {
                return $(this).css('color', 'black');
            } else {
                return $(this).css('color', '#9a9a9a');
            }
        });
    },
    populateFields: function() {
        const treatments = $('.populate-clinics').find('select').find(":selected").attr('data-treatments');
        let clinicEmail = $('.populate-clinics').find('select').find(":selected").attr('data-clinic-email');
        clinicEmail = clinicEmail ? clinicEmail : WPURLS.info_email;
        //console.log(clinicEmail);
        //console.log($(".clinic-email"));
        $(".clinic-email").find('input[type=email]').val(clinicEmail);
        if(typeof treatments != 'undefined') {
            const treatmentsArray = treatments.split(",");
            $('.populate-posts').find('select > option').each(function(e) {
                $(this).hide();
                if(jQuery.inArray($(this).attr('data-treatment-id'), treatmentsArray) != -1 || $(this).attr('data-treatment-id') == "custom") {
                    $(this).show();
                }
            })
        }
    },
    populateFieldsExpert: function() {
        const treatments = $("#modal-expert-booking").attr("data-treatments");
        if(typeof treatments != 'undefined') {
            const treatmentsArray = treatments.split(",");
            $('.populate-experts').find('select > option').each(function(e) {
                $(this).hide();
                if((jQuery.inArray($(this).attr('data-treatment-id'), treatmentsArray) != -1) || $(this).attr('data-treatment-id') == "custom") {
                    $(this).show();
                }
            })
        }
    }
};
  